<template>
    <div id="nova-analise-certificacao">
        <BaseHeader
            :titulo="$tc('certification.messages.new_analysis')"
            :exibeBotao="false"
            :voltarPara="true"
        />
        <div class="view-container margen-bottom-pages">
            <div class="bloco-lista-certificacoes-ativas">
                <BlocoListarAtivasCertificao
                    @emitIdsCertificacaoTipo="idsCertificacaoTipo"
                />
            </div>
            <div class="bloco-inserir-dados-certificacao">
                <BlocoInserirManualmenteCertificacao
                    @adicionarCertificacaoNaoEnviada="
                        adicionarCertificacaoNaoEnviadaManual
                    "
                />
                <BlocoInserirPlanilhaCertificacao
                    :territoriosNaoEnviados="dataTerritoriosNaoEnviados"
                    @adicionarCertificacaoNaoEnviadaPlanilha="
                        adicionarCertificacaoNaoEnviadaPlanilha
                    "
                />
            </div>
            <div class="bloco-tabela-territorio-nao-enviado">
                <BlocoTabelaNaoEnviadasCertificacao
                    :territoriosNaoEnviados="dataTerritoriosNaoEnviados"
                    :removendo="removendoTerritoriosCertificados"
                    @RemoverTerritorioLote="removerTerritorioLote"
                    ref="tabelaTerritorio"
                />
            </div>
            <footer>
                <div class="botao-certificacao__remover">
                    <el-button
                        v-if="removendoTerritoriosCertificados"
                        @click.native="removendoTerritoriosCertificados = false"
                    >
                        {{ $t('certification.words.cancel') }}
                    </el-button>
                    <el-button
                        v-if="!removendoTerritoriosCertificados"
                        type="danger"
                        icon="el-icon-delete"
                        @click.native="removendoTerritoriosCertificados = true"
                    >
                        {{ $t('certification.words.remove') }}
                    </el-button>
                    <el-button
                        v-else
                        type="danger"
                        icon="el-icon-delete"
                        @click.native="removerTerritorio"
                    >
                        {{ $t('certification.words.confirm') }}
                    </el-button>
                </div>
                <div class="botao-certificacao__enviar-para-analise">
                    <el-button
                        id="adicionar-analise"
                        type="primary"
                        icon="el-icon-data-line"
                        @click.native="realizarAnalise"
                    >
                        {{ $t('certification.messages.perform_new_analysis') }}
                    </el-button>
                </div>
            </footer>
        </div>
        <ModalCertificacoesExistentes
            v-if="!carregandoTabela"
            :mostrar="exibirModalCertificacoesExistentes"
            :lista="carsListComCertificacao"
            @fechar="fecharModalCertificacoesExistentes"
        />
    </div>
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BlocoListarAtivasCertificao from '@/modules/certification/views/components/BlocoListarAtivasCertificao.vue';
import BlocoInserirManualmenteCertificacao from '@/modules/certification/views/pages/create/components/BlocoInserirManualmenteCertificacao.vue';
import BlocoInserirPlanilhaCertificacao from '@/modules/certification/views/pages/create/components/BlocoInserirViaPlanilhaCertificacao.vue';
import BlocoTabelaNaoEnviadasCertificacao from '@/modules/certification/views/pages/create/components/TabelaNaoEnviadasCertificacao.vue';
import ModalCertificacoesExistentes from '@/modules/certification/views/pages/create/components/ModalCertificacoesExistentes.vue';
import CertificacaoService from '@/services/CertificacaoService';
import CarUtils from '@/utils/CarUtils';

export default {
    name: 'InserirCertificacao',
    components: {
        BaseHeader,
        BlocoListarAtivasCertificao,
        BlocoInserirManualmenteCertificacao,
        BlocoInserirPlanilhaCertificacao,
        BlocoTabelaNaoEnviadasCertificacao,
        ModalCertificacoesExistentes
    },
    data() {
        return {
            dataTerritoriosNaoEnviados: [],
            removendoTerritoriosCertificados: false,
            territoriosSelecionados: [],
            certificacao: {
                idsTerritorio: [],
                idsCertificacaoTipo: [],
                nomeTerritorioCar: []
            },
            exibirModalCertificacoesExistentes: false,
            params: {
                page: 0,
                size: 10,
                sort: 'dataCadastro',
                por: 'desc'
            },
            filtro: {
                pesquisaFiltro: '',
                estadoId: [],
                territoriosAnalisados: false,
                areaPlantadaElegivel: false
            },
            certificacoesLista: [],
            carregandoTabela: false,
            carsListComCertificacao: [],
            carList: []
        };
    },

    methods: {
        adicionarCertificacaoNaoEnviadaManual(territorio) {
            if (typeof territorio === 'string') {
                this.dataTerritoriosNaoEnviados.push({
                    id: null,
                    nome: territorio,
                    cars: [],
                    representantes: []
                });

                return;
            }

            const found = this.dataTerritoriosNaoEnviados.find(
                element => element.id === territorio.id
            );

            if (found) {
                this.$notify.error({
                    message: this.$t(
                        'certification.messages.territory_already_added_to_list'
                    )
                });
            } else {
                this.$refs.tabelaTerritorio.carregarTabela(true);
                this.dataTerritoriosNaoEnviados.push(territorio);
            }
            setTimeout(() => {
                this.$refs.tabelaTerritorio.carregarTabela(false);
            }, 500);
        },

        adicionarCertificacaoNaoEnviadaPlanilha(dadosPlanilha) {
            this.dataTerritoriosNaoEnviados = [];
            Object.keys(dadosPlanilha.itens).forEach(territorio => {
                this.dataTerritoriosNaoEnviados.push(
                    dadosPlanilha.itens[territorio]
                );
            });
        },

        removerTerritorioLote(idsTerritorios) {
            this.territoriosSelecionados = idsTerritorios;
        },

        async removerTerritorio() {
            if (this.territoriosSelecionados.length === 0) {
                this.$notify.warning(
                    this.$t(
                        'certification.messages.no_territories_selected_for_removal'
                    )
                );
            } else {
                await this.$messageBox.confirm(
                    this.$tc(
                        'certification.messages.remove_selected_territory',
                        this.territoriosSelecionados.length
                    ),
                    this.$t('certification.words.warning'),
                    {
                        confirmButtonText: this.$t('certification.words.yes'),
                        cancelButtonText: this.$t('certification.words.no'),
                        type: 'warning'
                    }
                );
                try {
                    this.$nextTick(() => {
                        this.$refs.tabelaTerritorio.removerTerritorio(
                            this.territoriosSelecionados
                        );
                    });
                } catch (error) {
                    this.$notify.error({
                        message: this.$t(
                            'certification.messages.errors.error_request_remove_territory'
                        )
                    });
                }
                this.$notify.success(
                    this.$tc(
                        'certification.messages.territory_removed',
                        this.territoriosSelecionados.length
                    )
                );
            }
        },

        idsCertificacaoTipo(idsCertificacaoTipo) {
            this.certificacao.idsCertificacaoTipo = idsCertificacaoTipo.idsTipo;
        },

        realizarAnalise() {
            if (!this.dataTerritoriosNaoEnviados.length) {
                this.$notify.error({
                    message: this.$t(
                        'certification.messages.necessary_at_least_one_certification'
                    )
                });
                return;
            }

            if (!this.certificacao.idsCertificacaoTipo.length) {
                this.$notify.error({
                    message: this.$t(
                        'certification.messages.necessary_at_least_one_certification'
                    )
                });
                return;
            }

            this.certificacao.idsTerritorio = this.dataTerritoriosNaoEnviados
                .map(obj => (CarUtils.isCar(obj.nome) ? obj.nome : obj.id))
                .filter(item => item !== null && item !== undefined);

            this.certificacao.nomeTerritorioCar = [];
            this.dataTerritoriosNaoEnviados.forEach(obj => {
                if (obj.id === undefined) {
                    this.certificacao.nomeTerritorioCar.push({
                        nomeTerritorio: obj.nome,
                        codigoCAR: obj.cars.length ? obj.cars[0].codigo : null,
                        nomeRepresentante:
                            obj.representanteNovo !== undefined &&
                            obj.representanteNovo.length
                                ? obj.representanteNovo[0].nomeRazaoSocial
                                : null,
                        cpfCnpj:
                            obj.representanteNovo !== undefined &&
                            obj.representanteNovo.length
                                ? obj.representanteNovo[0].cpfCnpjDecrypt
                                : null
                    });
                }
            });
            this.buscarCertificacoes();
        },

        verificaCertificacoesExistentes(listaDeCarsByApi) {
            this.dataTerritoriosNaoEnviados.map(territorio =>
                territorio.cars.map(car => this.carsList.push(car.codigo))
            );

            listaDeCarsByApi.forEach(carByApi => {
                carByApi.cars.map(car => {
                    if (
                        this.carsList.includes(car.codigo) &&
                        carByApi.certificacaoStatus.some(
                            el => el.status === true
                        )
                    ) {
                        this.carsListComCertificacao.push(carByApi);
                    }
                });
            });

            this.carsListComCertificacao = this.removeItemsDuplicadosPorId(
                this.carsListComCertificacao
            );

            if (this.carsListComCertificacao.length > 0) {
                this.exibirModalCertificacoesExistentes = true;
            } else {
                this.inserirCertificacaoTerritorio();
            }
        },

        removeItemsDuplicadosPorId(arr) {
            return arr.reduce((acc, current) => {
                if (!acc.some(item => item.id === current.id)) {
                    acc.push(current);
                }
                return acc;
            }, []);
        },

        async buscarCertificacoes() {
            this.carregandoTabela = true;
            this.carsList = [];
            try {
                const { data } = await CertificacaoService.buscarCertificacoes(
                    this.filtro,
                    this.params,
                    true
                );
                this.certificacoesLista = data.itens;
                this.verificaCertificacoesExistentes(data.itens);
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'certification.messages.unable_to_search_territories'
                    )
                });
            }
            this.carregandoTabela = false;
        },

        fecharModalCertificacoesExistentes(confirma) {
            this.exibirModalCertificacoesExistentes = false;
            if (confirma) {
                this.inserirCertificacaoTerritorio();
            }
        },

        inserirCertificacaoTerritorio() {
            CertificacaoService.InserirCertificacaoTerritorio({
                idTerritorio: this.certificacao.idsTerritorio,
                idCertificacaoTipo: this.certificacao.idsCertificacaoTipo,
                nomeTerritorioCar: this.certificacao.nomeTerritorioCar
            }).catch(() => {
                this.$notify.error({
                        message: this.$t(
                            'certification.words.error'
                        )
                    });
            });
            this.$router.push({ name: 'Certificacao' });
        }
    }
};
</script>

<style lang="scss" scoped>
#nova-analise-certificacao {
    .bloco-lista-certificacoes-ativas,
    .bloco-inserir-dados-certificacao,
    .bloco-listagem-territorio-contrato,
    .bloco-view-container-down,
    .bloco-tabela-territorio-nao-enviado {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
    }

    .bloco-inserir-dados-certificacao {
        justify-content: space-between;
        gap: 15px;
        width: 100%;
        margin-top: 20px;
        flex-direction: row;

        .el-card__body {
            align-items: stretch;
        }
    }

    .bloco-lista-certificacoes-ativas {
        justify-content: space-between;
        gap: 4px;

        .el-card__body {
            align-items: stretch;
        }
    }

    .bloco-view-container-down {
        gap: 15px;
        width: 100%;
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;

        .bloco-view-container-down__conteudo__remove-item {
            el-link {
                color: var(--hover-danger);
            }
        }

        .bloco-view-container-down__conteudo__buttons {
            display: flex;
            gap: 10px;
        }
    }

    footer {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .botao-certificacao__remover,
        .botao-certificacao__enviar-para-analise {
            margin-top: 16px;

            .lyra-icon.lyra-grafico-3 ::after {
                color: white;
            }

            #adicionar-analise {
                span {
                    margin-left: 5px;
                }
            }
        }
    }
}
</style>
